import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkOnAddRelease } from '../types';

const onAddRelease: IThunkOnAddRelease = thunk(async (_, payload) => {
  await api.release.addRelease(payload);
});

export default onAddRelease;
